module.exports = __webpack_public_path__ + "static/media/img_2.ed881b42.png";